import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Api from '@/api';

// import Data from '@flow/shared/src/data/vr-sample';
import EdutechKO00 from '@/data/vr-edutech00-ko';
import EdutechEN00 from '@/data/vr-edutech00-en';
// import Edutech01 from '@/data/vr-edutech01';
// import Edutech02 from '@/data/vr-edutech02';
// import Edutech03 from '@/data/vr-edutech03';
// import Edutech04 from '@/data/vr-edutech04';
import EdutechConf from '@/data/vr-edutech-conf';

const edutechData = {
  '1': EdutechKO00,
  '2': EdutechEN00,
  // '3': Edutech02,
  // '4': Edutech03,
  '5': EdutechConf,
};

export interface State {
  initialized: boolean;
  model: any;
  userInfo: any;
}

@Module({ namespaced: true })
class VRPlayer extends VuexModule implements State {
  model = {};
  userInfo = {};
  hasFullscreen = true;
  initialized = false;

  @Mutation
  private INIT({
    model,
    userInfo,
    hasFullscreen,
  }: {
    model: any;
    userInfo: any;
    hasFullscreen: boolean;
  }) {
    this.model = model;
    this.userInfo = userInfo;
    this.initialized = true;
    this.hasFullscreen = hasFullscreen;
  }

  @Action({ rawError: true })
  private async init() {
    const playerID = this.context.rootState.route.params.playerId as string;

    if (playerID != '1' && playerID != '2' && playerID != '5') {
      const { data } = await Api.getTourInfo(playerID);

      const userInfo = this.context.rootState.route.query['user_info'];
      const userInfoData = (() => {
        if (userInfo) {
          const decodedUserInfo = atob(userInfo);
          try {
            return JSON.parse(decodedUserInfo);
          } catch (e) {
            return {};
          }
        } else {
          return {};
        }
      })();

      this.context.commit('INIT', {
        model: data,
        userInfo: userInfoData,
        hasFullscreen: !this.context.rootState.route.query['no_fullscreen'],
      });
    } else {
      // TODO : api로 대체 필요
      return new Promise((resolve) => {
        setTimeout(() => {
          this.context.commit('INIT', {
            model: edutechData[playerID].data,
          });
          resolve();
        }, 100);
      });
    }
  }
}

export default VRPlayer;
